export function getTypewriterStep(bufferedChars: number): number {
  if (bufferedChars >= 40) return 4
  if (bufferedChars >= 18) return 2
  return 1
}

export function getNextTypedLength(currentLength: number, targetLength: number): number {
  const remaining = Math.max(0, targetLength - currentLength)
  if (remaining === 0) return targetLength
  if (remaining <= 2) return targetLength
  return Math.min(targetLength, currentLength + getTypewriterStep(remaining))
}
